<template>
  <div class="form-inline">
    <select v-model="filter.operator" class="form-control form-control-sm">
      <option v-for="operator in operators" :value="operator.value">
        {{ operator.label }}
      </option>
    </select>
    <input
      v-if="filter.operator !== 'isNull'"
      v-model.trim="filter.value"
      class="form-control form-control-sm"
      @keyup.enter="$emit('submit')"
    >
  </div>
</template>

<script>
  import { operators } from './text';

  export default {
    props: {
      filter: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        operators
      };
    },
    beforeMount() {
      if (!this.filter.value) {
        this.filter.value = '';
      }
      if (!this.filter.operator) {
        this.filter.operator = operators[0].value;
      }
    },
  };
</script>
